/* Love N Care — cart delivery options + promo + cross-sell (design cart.dc.html).
   Drives the "Delivery to" postcode flow on the cart page summary card and the
   drawer footer. Rates come from Shopify's own cart endpoints (prepare/async
   shipping rates), so what's shown always equals checkout. Delegation-based:
   all listeners live on document so AJAX section swaps never orphan them; a
   MutationObserver re-hydrates the UI after cart.js replaces the markup. */
(function () {
  if (window.__lncCart) return;
  window.__lncCart = true;

  var ZIP_KEY = 'lnc-ship-estimate'; // { zip } — shared with the old estimator
  var CHOICE_KEY = 'lnc-ship-choice'; // chosen rate name
  var PROMO_KEY = 'lnc-promo-code';

  var ratesCache = {}; // zip|totalCents -> array of rates
  var pendingKey = null;
  var collapseAfterRates = false;
  // Options list collapses to just the chosen row once a choice is made
  // (expanded again on "new postcode" or by clicking the collapsed row).
  var optsCollapsed = !!ls('lnc-ship-choice');

  function stateFromZip(zip) {
    var n = parseInt(zip, 10);
    if (isNaN(n)) return null;
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return ['ACT', 'Australian Capital Territory'];
    if (n >= 800 && n <= 999) return ['NT', 'Northern Territory'];
    if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return ['NSW', 'New South Wales'];
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return ['VIC', 'Victoria'];
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return ['QLD', 'Queensland'];
    if (n >= 5000 && n <= 5999) return ['SA', 'South Australia'];
    if (n >= 6000 && n <= 6999) return ['WA', 'Western Australia'];
    if (n >= 7000 && n <= 7999) return ['TAS', 'Tasmania'];
    return null;
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function priceLabel(cents) {
    return cents === 0 ? 'Free' : money(cents);
  }

  function ls(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, val) {
    try { val === null ? localStorage.removeItem(key) : localStorage.setItem(key, val); } catch (e) { /* ignore */ }
  }
  function savedZip() {
    try {
      var saved = JSON.parse(ls(ZIP_KEY) || 'null');
      return saved && /^[0-9]{4}$/.test(saved.zip || '') ? saved.zip : null;
    } catch (e) { return null; }
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-lnc-ship]'));
  }

  /* ---------- rate fetching (Shopify cart endpoints = checkout parity) ---------- */

  function fetchRates(zip, key, done, fail) {
    var st = stateFromZip(zip);
    if (!st) return fail('Enter a valid 4-digit Australian postcode.');
    var qs = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) +
      '&shipping_address%5Bcountry%5D=Australia' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(st[1]);
    fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('prepare failed');
        poll(0);
      })
      .catch(function () { fail('Couldn’t get rates just now — please try again.'); });

    function poll(tries) {
      if (pendingKey !== key) return; // superseded by a newer request
      if (tries > 20) return fail('That took too long — please try again.');
      fetch('/cart/async_shipping_rates.json', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (pendingKey !== key) return;
          if (!data || data.shipping_rates === null || data.shipping_rates === undefined) {
            setTimeout(function () { poll(tries + 1); }, 500);
            return;
          }
          done(data.shipping_rates);
        })
        .catch(function () { setTimeout(function () { poll(tries + 1); }, 700); });
    }
  }

  /* Normalise: carrier rates (dollar strings) + pickup → [{name, desc, cents}] */
  function buildOptions(root, rawRates, zip) {
    var opts = rawRates.map(function (r) {
      return { name: r.name, desc: r.description || '', cents: Math.round(parseFloat(r.price) * 100) };
    });
    var pickupLabel = root.getAttribute('data-pickup-label');
    var st = stateFromZip(zip);
    if (pickupLabel && st && st[0] === 'NSW') {
      opts.push({ name: pickupLabel, desc: root.getAttribute('data-pickup-desc') || '', cents: 0, pickup: true });
    }
    return opts;
  }

  /* ---------- rendering ---------- */

  function show(root, sel, on) {
    var el = root.querySelector(sel);
    if (el) el.hidden = !on;
  }
  function setText(root, sel, text) {
    var el = root.querySelector(sel);
    if (el) el.textContent = text;
  }

  function renderError(root, msg) {
    var err = root.querySelector('[data-lnc-pc-err]');
    if (err) { err.textContent = msg; err.hidden = !msg; }
  }

  function renderZipState(root) {
    var zip = savedZip();
    show(root, '[data-lnc-pc-unset]', !zip);
    show(root, '[data-lnc-pc-set]', !!zip);
    var cancel = root.querySelector('[data-lnc-pc-cancel]');
    if (cancel) cancel.hidden = true;
    if (zip) {
      var st = stateFromZip(zip);
      setText(root, '[data-lnc-pc-label]', (st ? st[0] + ' ' : '') + zip);
    }
    var delivery = root.querySelector('[data-lnc-delivery]');
    if (delivery && !zip) { delivery.textContent = 'Add postcode'; delivery.classList.add('is-unset'); }
    syncDrawerSummary();
  }

  function renderOptions(root, opts) {
    var box = root.querySelector('[data-lnc-opts]');
    if (!box) return;
    var compact = root.getAttribute('data-ctx') === 'drawer';
    if (!opts) { box.hidden = true; box.innerHTML = ''; updateTotals(root, null); return; }
    if (!opts.length) {
      box.hidden = false;
      box.innerHTML = '<div class="lnc-summary__optnote">Sorry — we can’t deliver to that postcode. Call 1300 732 599 and we’ll help.</div>';
      updateTotals(root, null);
      return;
    }
    var chosenName = ls(CHOICE_KEY);
    var chosen = opts.filter(function (o) { return o.name === chosenName; })[0] || opts[0];
    var collapsed = optsCollapsed && opts.length > 1;
    var shown = collapsed ? [chosen] : opts;
    box.hidden = false;
    box.innerHTML = shown.map(function (o) {
      var on = o.name === chosen.name;
      var descParts = (o.desc || '').split(' · ').filter(function (d) { return !/signature/i.test(d); });
      var desc = compact ? (descParts[0] || '') : descParts.join(' · ');
      return '<button type="button" class="lnc-shipopt' + (on ? ' is-active' : '') + (collapsed ? ' is-collapsed' : '') + '"' +
        ' data-lnc-opt="' + o.name.replace(/"/g, '&quot;') + '" data-cents="' + o.cents + '"' +
        (collapsed ? ' aria-expanded="false" title="Change delivery option"' : ' aria-expanded="true"') + '>' +
        '<span class="lnc-shipopt__dot"><span class="lnc-shipopt__dotfill"></span></span>' +
        '<span><span class="lnc-shipopt__name">' + o.name + '</span>' +
        (desc ? '<span class="lnc-shipopt__eta">' + desc + '</span>' : '') + '</span>' +
        '<span class="lnc-shipopt__price' + (o.cents === 0 ? ' is-free' : '') + '">' + priceLabel(o.cents) + '</span>' +
        (collapsed ? '<span class="lnc-shipopt__chev" aria-hidden="true">&#9662;</span>' : '') +
        '</button>';
    }).join('');
    updateTotals(root, chosen);
    syncDrawerSummary();
  }

  function updateTotals(rootEl, chosen) {
    // Totals live inside the summary card on the page, but in the drawer they
    // sit in a sibling band — widen the scope to the shared footer wrapper.
    var root = rootEl.closest('.cart-drawer__footer') || rootEl;
    var base = parseInt(rootEl.getAttribute('data-total'), 10) || 0;
    var total = base + (chosen ? chosen.cents : 0);
    var delivery = root.querySelector('[data-lnc-delivery]');
    if (delivery) {
      if (chosen) { delivery.textContent = priceLabel(chosen.cents); delivery.classList.remove('is-unset'); }
      else if (savedZip()) { delivery.textContent = '—'; delivery.classList.remove('is-unset'); }
      else { delivery.textContent = 'Add postcode'; delivery.classList.add('is-unset'); }
    }
    setText(root, '[data-lnc-total]', money(total));
    setText(root, '[data-lnc-afterpay]', money(Math.round(total / 4)));
    var apWrap = root.querySelector('[data-afterpay-wrap]');
    if (apWrap) { var apMax = parseInt(apWrap.getAttribute('data-afterpay-max'), 10) || 0; apWrap.hidden = !(total > 0 && (apMax === 0 || total <= apMax)); }
    var label = root.querySelector('[data-lnc-total-label]');
    if (label) label.textContent = chosen ? 'Total' : 'Subtotal';
    if (rootEl.getAttribute('data-ctx') === 'page') { // pinned mobile checkout bar mirrors the summary
      setText(document, '[data-lnc-sticky-total]', money(total));
      setText(document, '[data-lnc-sticky-label]', chosen ? 'Total' : 'Subtotal');
    }
    var note = root.querySelector('[data-lnc-shipnote]');
    if (note) note.textContent = chosen ? chosen.name + ' ' + priceLabel(chosen.cents) : 'enter your postcode above for delivery';
  }

  function renderPromo(root) {
    var code = ls(PROMO_KEY);
    show(root, '[data-lnc-promo-unset]', !code);
    show(root, '[data-lnc-promo-set]', !!code);
    if (code) setText(root, '[data-lnc-promo-code]', code);
  }

  /* Tell the delivery-offer bar (lnc-ship-offer.js) the real rates for this postcode + cart total.
     rates: array of {name, cents} (empty = can't deliver), or null = lookup failed. */
  function emitRates(zip, total, rates) {
    document.dispatchEvent(new CustomEvent('lnc:rates', { detail: { zip: zip, total: total, rates: rates && rates.map(function (r) {
      return { name: r.name, cents: Math.round(parseFloat(r.price) * 100) };
    }) } }));
    publishBagDelivery(zip, rates);
  }

  /* Shopper journey alerts (Discord): Shopify's own events don't include the bag's postcode box, so publish a
     custom customer event the "LNC Alerts" pixel subscribes to. Only when the postcode or the Standard price
     changes, so cart refreshes don't re-ping. */
  function publishBagDelivery(zip, rates) {
    if (!rates || !(window.Shopify && Shopify.analytics && Shopify.analytics.publish)) return;
    var st = stateFromZip(zip);
    var std = rates.filter(function (r) { return /standard/i.test(r.name); })[0] || rates[0];
    var data = { zip: zip, state: st ? st[0] : '', none: !rates.length, option: std ? std.name : '', price: std ? parseFloat(std.price) : 0 };
    var key = zip + '|' + data.price + '|' + data.none;
    try { if (sessionStorage.getItem('lnc-bag-pub') === key) return; sessionStorage.setItem('lnc-bag-pub', key); } catch (e) {}
    try { Shopify.analytics.publish('lnc_bag_delivery', data); } catch (e) {}
  }

  function loadRates(zip) {
    var anyRoot = roots()[0];
    if (!anyRoot) return;
    var total = parseInt(anyRoot.getAttribute('data-total'), 10) || 0;
    var key = zip + '|' + anyRoot.getAttribute('data-total');
    if (ratesCache[key]) {
      // A cached cart state wins: any quote still running for an older cart (e.g. + then − before it came back)
      // must not land afterwards and overwrite this one (2 Nov 2026: a late failure wiped the delivery off the total).
      pendingKey = null;
      roots().forEach(function (root) { renderOptions(root, buildOptions(root, ratesCache[key], zip)); });
      emitRates(zip, total, ratesCache[key]);
      return;
    }
    pendingKey = key;
    roots().forEach(function (root) {
      var box = root.querySelector('[data-lnc-opts]');
      if (box) { box.hidden = false; box.innerHTML = '<div class="lnc-summary__optnote" data-lnc-checking>Checking delivery for ' + zip + '…</div>'; }
    });
    syncDrawerSummary(); // collapsed row says "Checking price…" while Shopify quotes (can take 5–8 s)
    var attempt = function (retriesLeft) {
      fetchRates(zip, key, function (rates) {
        ratesCache[key] = rates;
        if (pendingKey !== key) return; // superseded by a newer cart state
        pendingKey = null;
        roots().forEach(function (root) { renderOptions(root, buildOptions(root, rates, zip)); });
        emitRates(zip, total, rates);
        // Postcode typed in the drawer → fold back to the one-line summary once priced, so the bag stays in view.
        if (collapseAfterRates) { collapseAfterRates = false; closeDrawerCollapseSoon(); }
      }, function (msg) {
        if (pendingKey !== key) return; // superseded: a newer cart state is already shown
        /* One silent retry — a transient quote failure right after a cart change
           looked like "shipping disappeared and never came back". */
        if (retriesLeft > 0) { setTimeout(function () { attempt(retriesLeft - 1); }, 1500); return; }
        pendingKey = null;
        emitRates(zip, total, null);
        roots().forEach(function (root) {
          renderError(root, msg);
          var box = root.querySelector('[data-lnc-opts]');
          if (box) { box.hidden = true; box.innerHTML = ''; }
        });
      });
    };
    attempt(1);
  }

  function hydrate() {
    var zip = savedZip();
    roots().forEach(function (root) {
      renderZipState(root);
      renderPromo(root);
      if (!zip) renderOptions(root, null);
    });
    if (zip && roots().length) loadRates(zip);
  }


  /* ---------- delivery preference / authority to leave ----------
     Cart attributes: "Authority to leave" Yes|No + "Delivery preference" (label).
     Order note gets an "ATL — Authority to leave" prefix so the Shippit app prints it. */
  var ATL_PREFIX = 'ATL - Authority to leave. Safe place if not home.'; /* ≤55 chars: Shippit delivery_instructions limit */
  var ATL_NOTES = {
    Yes: 'The courier may leave your parcel unattended at your address. Love N Care and the courier can\'t take responsibility for it once delivered.',
    No: 'Someone will need to sign for the delivery. Choose "Leave in a safe place" to authorise the courier to leave it.'
  };
  function atlRender(value) {
    setTimeout(syncDrawerSummary, 0);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lnc-atl]'), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-lnc-atl-input]'), function (i) { i.checked = (i.value === value); });
      var n = root.querySelector('[data-lnc-atl-note]'); if (n) n.textContent = ATL_NOTES[value] || '';
    });
  }
  function atlSave(value) {
    atlRender(value);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var note = (cart.note || '').replace(ATL_PREFIX, '').replace(/^\s+/, '');
        if (value === 'Yes') note = ATL_PREFIX + (note ? '\n' + note : '');
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note, attributes: { 'Authority to leave': value, 'Delivery preference': value === 'Yes' ? 'Leave in a safe place (authority to leave)' : 'Signature required' } })
        });
      })
      .catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-lnc-atl-input') && t.checked) atlSave(t.value);
  });


  /* ---------- drawer: collapsible delivery block ----------
     One summary row ("NSW 2196 · Standard $20 · Signature required"); opens on click,
     closes ~0.4s after a delivery or leave-safe choice so the bag stays visible. */
  function drawerCollapse() { return document.querySelector('[data-lnc-dcol]'); }
  function syncDrawerSummary() {
    var det = drawerCollapse(); if (!det) return;
    var text = det.querySelector('[data-lnc-dcol-text]'); if (!text) return;
    var zip = savedZip();
    // 6 Oct 2026: this row is the drawer's ONLY delivery UI. No postcode → shown open as just the postcode box
    // (summary + leave-safe hidden via .is-unset). With a postcode → collapsed summary "VIC 3029 · Standard $18.76".
    det.hidden = false;
    var wasUnset = det.classList.contains('is-unset');
    det.classList.toggle('is-unset', !zip);
    if (!zip) { det.open = true; text.textContent = 'Add your postcode for delivery'; text.classList.add('is-unset'); return; }
    if (wasUnset) det.open = false; // postcode just entered → collapse to the one-line summary; tap to see options
    var st = stateFromZip(zip);
    var parts = [(st ? st[0] + ' ' : '') + zip];
    var active = det.querySelector('.lnc-shipopt.is-active');
    if (active) {
      var nm = active.querySelector('.lnc-shipopt__name'); var pr = active.querySelector('.lnc-shipopt__price');
      var shortName = (nm ? nm.textContent : '').replace(/\s*delivery\s*$/i, '').trim();
      var price = pr ? pr.textContent.replace(/\.00$/, '').trim() : '';
      // "Standard Free" read oddly (owner, 6 Oct) → "Free delivery"
      if (/^free$/i.test(price) && /^standard$/i.test(shortName)) parts.push('Free delivery');
      else parts.push((shortName + (price ? ' ' + price : '')).replace(/\s+/g, ' ').trim());
    }
    if (!active && det.querySelector('[data-lnc-checking]')) { parts.push('Checking price…'); text.textContent = parts.join(' · '); text.classList.remove('is-unset'); return; }
    var cant = !active && det.querySelector('[data-lnc-opts] .lnc-summary__optnote');
    if (cant) { parts.push('Can’t deliver here'); text.textContent = parts.join(' · '); text.classList.remove('is-unset'); return; }
    var atl = det.querySelector('[data-lnc-atl-input]:checked');
    // Signature is the default, so only the leave-safe choice is worth the space (keeps the price visible on phones).
    if (atl && atl.value === 'Yes') parts.push('Leave safe');
    text.textContent = parts.join(' · '); text.classList.remove('is-unset');
  }
  var closeTimer = null;
  function closeDrawerCollapseSoon() {
    var det = drawerCollapse(); if (!det) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { syncDrawerSummary(); det.open = false; }, 450);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opt = t.closest && t.closest('[data-lnc-dcol] [data-lnc-opt]');
    if (opt && !opt.classList.contains('is-collapsed')) closeDrawerCollapseSoon();
    var go = t.closest && t.closest('[data-lnc-dcol] [data-lnc-pc-go]');
    if (go) { var d = drawerCollapse(); if (d) d.open = true; }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-lnc-atl-input') && t.closest('[data-lnc-dcol]')) closeDrawerCollapseSoon();
  });

  /* ---------- actions ---------- */

  function submitZip(root) {
    var input = root.querySelector('[data-lnc-pc-input]');
    var zip = ((input || {}).value || '').trim();
    if (!/^[0-9]{4}$/.test(zip) || !stateFromZip(zip)) {
      renderError(root, 'Enter a 4-digit Australian postcode.');
      return;
    }
    renderError(root, '');
    lsSet(ZIP_KEY, JSON.stringify({ zip: zip }));
    lsSet(CHOICE_KEY, null);
    optsCollapsed = false; // fresh postcode → show every option
    collapseAfterRates = !!(root.closest && root.closest('[data-lnc-dcol]'));
    roots().forEach(renderZipState);
    loadRates(zip);
    // delivery-offer bar (lnc-ship-offer.js) shares the postcode — tell it to re-render
    document.dispatchEvent(new CustomEvent('lnc:postcode', { detail: { zip: zip, source: 'cart' } }));
  }

  /* Postcode entered in the delivery-offer bar/callout → load real rates here too, so the
     customer only types it once. */
  document.addEventListener('lnc:postcode', function (e) {
    var d = e.detail || {};
    if (d.source === 'cart' || !/^[0-9]{4}$/.test(d.zip || '') || !stateFromZip(d.zip)) return;
    lsSet(CHOICE_KEY, null);
    optsCollapsed = false;
    roots().forEach(renderZipState);
    if (roots().length) loadRates(d.zip);
    syncDrawerSummary();
  });

  /* "Change" is an EDIT, not a reset (owner: hitting it by accident wiped the
     postcode and shipping never came back). The saved postcode stays until a new
     valid one is submitted; Cancel returns to the set view untouched. */
  function changeZip() {
    var zip = savedZip();
    roots().forEach(function (root) {
      show(root, '[data-lnc-pc-unset]', true);
      show(root, '[data-lnc-pc-set]', false);
      renderError(root, '');
      var input = root.querySelector('[data-lnc-pc-input]');
      if (input) { input.value = zip || ''; try { input.focus(); input.select(); } catch (e) {} }
      var cancel = root.querySelector('[data-lnc-pc-cancel]');
      if (cancel) cancel.hidden = !zip;
    });
  }

  function cancelZip() {
    roots().forEach(function (root) {
      renderZipState(root);
      renderError(root, '');
      var cancel = root.querySelector('[data-lnc-pc-cancel]');
      if (cancel) cancel.hidden = true;
    });
  }

  /* Re-render the cart page section AND the drawer server-side
     (discount rows, totals, item rows) after a cart mutation. */
  function refreshSections() {
    var itemsEl = document.getElementById('main-cart-items');
    var pagePromise = !itemsEl ? Promise.resolve()
      : fetch('/cart?sections=' + encodeURIComponent(itemsEl.dataset.id))
        .then(function (r) { return r.json(); })
        .then(function (rendered) {
          var html = new DOMParser().parseFromString(rendered[itemsEl.dataset.id], 'text/html');
          var fresh = html.querySelector('.js-contents');
          var target = itemsEl.querySelector('.js-contents');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });
    var drawerPromise = !document.querySelector('cart-drawer') ? Promise.resolve()
      : fetch('/?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var html = new DOMParser().parseFromString(txt, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer', '.lnc-shipbar'].forEach(function (sel) {
            var target = document.querySelector(sel);
            var source = html.querySelector(sel);
            if (target && source) target.replaceWith(source);
          });
        });
    return Promise.all([pagePromise, drawerPromise]).catch(function () { /* partial refresh is fine */ });
  }

  /* Discount codes go through Shopify's cart API, which validates them for
     real (applicable:false = bad code) and puts the amount in the cart totals
     — so the summary shows the discount immediately, not just at checkout. */
  function applyPromo(root) {
    var input = root.querySelector('[data-lnc-promo-input]');
    var code = ((input || {}).value || '').trim();
    var err = root.querySelector('[data-lnc-promo-err]');
    function fail(msg) {
      if (err) { err.textContent = msg; err.hidden = false; }
    }
    if (!/^[A-Za-z0-9_-]{2,40}$/.test(code)) {
      return fail(code ? 'That doesn’t look like a valid code.' : 'Enter a code to apply.');
    }
    if (err) err.hidden = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) {
          return (d.code || '').toUpperCase() === code.toUpperCase();
        })[0];
        if (entry && entry.applicable !== false) {
          lsSet(PROMO_KEY, code.toUpperCase());
          ratesCache = {}; // totals changed — free-shipping threshold may flip
          refreshSections().then(hydrate);
        } else {
          // Remove the rejected code so it doesn't linger on the cart.
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' })
          }).catch(function () { /* nothing to clean */ });
          fail('That code isn’t valid or has expired.');
        }
      })
      .catch(function () { fail('Couldn’t apply that just now — please try again.'); });
  }

  function clearPromo() {
    lsSet(PROMO_KEY, null);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () {
        ratesCache = {};
        refreshSections().then(hydrate);
      })
      .catch(function () { roots().forEach(renderPromo); });
  }

  function addCrossSell(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var itemsEl = document.getElementById('main-cart-items');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        // Re-fetch the freshly rendered cart section — deterministic (the
        // inline `sections` payload on add.js proved flaky on first hit).
        return refreshSections();
      })
      .then(function () {
        // refresh the header cart bubble
        fetch(window.location.pathname + '?sections=cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (s) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && s['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
              var inner = doc.querySelector('.shopify-section');
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
          })
          .catch(function () { /* cosmetic only */ });
        ratesCache = {}; // cart changed — old quotes are stale
        hydrate();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }

  /* ---------- delegation ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    var go = t.closest && t.closest('[data-lnc-pc-go]');
    if (go) return submitZip(go.closest('[data-lnc-ship]'));
    var change = t.closest && t.closest('[data-lnc-pc-change]');
    if (change) return changeZip();
    var cancel = t.closest && t.closest('[data-lnc-pc-cancel]');
    if (cancel) return cancelZip();
    var promoGo = t.closest && t.closest('[data-lnc-promo-go]');
    if (promoGo) return applyPromo(promoGo.closest('[data-lnc-ship]'));
    var promoClear = t.closest && t.closest('[data-lnc-promo-clear]');
    if (promoClear) return clearPromo();
    var opt = t.closest && t.closest('[data-lnc-opt]');
    if (opt) {
      if (opt.classList.contains('is-collapsed')) {
        optsCollapsed = false; // clicking the chosen row re-opens the list
      } else {
        lsSet(CHOICE_KEY, opt.getAttribute('data-lnc-opt'));
        optsCollapsed = true; // picking an option collapses the rest away
      }
      var zip = savedZip();
      if (zip) loadRates(zip);
      return;
    }
    var cs = t.closest && t.closest('[data-lnc-cs-add]');
    if (cs) return addCrossSell(cs);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var pc = e.target.closest && e.target.closest('[data-lnc-pc-input]');
    if (pc) { e.preventDefault(); return submitZip(pc.closest('[data-lnc-ship]')); }
    var promo = e.target.closest && e.target.closest('[data-lnc-promo-input]');
    if (promo) { e.preventDefault(); return applyPromo(promo.closest('[data-lnc-ship]')); }
  });

  document.addEventListener('input', function (e) {
    var pc = e.target.closest && e.target.closest('[data-lnc-pc-input]');
    if (pc) pc.value = pc.value.replace(/[^0-9]/g, '').slice(0, 4);
  });

  /* Re-hydrate after cart.js swaps the summary / drawer footer. The totals
     baked into data-total change with the cart, so quotes must refresh too. */
  var scheduled = null;
  var observer = new MutationObserver(function (muts) {
    var relevant = muts.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches && n.matches('[data-lnc-ship]') || (n.querySelector && n.querySelector('[data-lnc-ship]')));
      });
    });
    if (!relevant) return;
    clearTimeout(scheduled);
    scheduled = setTimeout(hydrate, 60);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
